const ptBR = {
  'modal.close': 'Fechar',
  'session_expired.title': 'A sessão expirou',
  'tokenizationForm.payment-terms.text1':
    'Autorizo a Flywire a armazenar e cobrar automaticamente no meu cartão de débito/crédito em nome de {{recipientName}}. Li, compreendi e concordo com',
  'tokenizationForm.general-terms.link2': 'Política de Privacidade',
  'tokenizationForm.general-terms.link-joint': ' e ',
  'tokenizationForm.general-terms.link1': 'Termos de Uso',
  'tokenizationForm.payment-terms.link': 'os Termos de Uso da Flywire para pagamentos automáticos',
  'tokenizationForm.labels.cvvTooltip': '3 dígitos no verso do cartão ou 4 dígitos na frente',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'Data de validade (MM/AA)',
  'tokenizationForm.labels.cardNumber': 'Número do cartão',
  'tokenizationForm.labels.phone': 'Número de celular',
  'tokenizationForm.labels.upopPhone':
    'Informe o número de celular vinculado a este cartão bancário',
  'tokenizationForm.labels.zip': 'CEP',
  'tokenizationForm.labels.address': 'Endereço',
  'cardsForm.labels.state': 'Estado',
  'tokenizationForm.labels.country': 'País ou região',
  'tokenizationForm.labels.city': 'Cidade',
  'tokenizationForm.labels.email': 'E-mail',
  'tokenizationForm.labels.lastName': 'Sobrenome',
  'tokenizationForm.labels.firstName': 'Nome',
  'cardsForm.title': 'Informações do titular do cartão',
  'success.title': 'Seus fundos estão a caminho',
  'success.title.info':
    'Aguarde de 2 a 3 dias úteis para que os fundos cheguem.\nVocê receberá um e-mail quando os fundos forem entregues.',
  'bankAccountForm.hints.generic': 'Exemplo: {{label}}',
  'bankAccountForm.hints.account_number': 'O número da conta deve ter entre 1 e 17 caracteres',
  'bankAccountForm.hints.routing_number': 'O número de roteamento deve ter 9 dígitos',
  'bankAccountForm.labels.accountZipCode': 'CEP',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'Código BIC',
  'bankAccountForm.labels.accountNumber': 'Número da conta',
  'bankAccountForm.labels.accountSortCode': 'Sort code',
  'bankAccountForm.labels.accountRoutingNumber': 'Número de roteamento',
  'bankAccountForm.labels.accountType': 'Tipo de conta',
  'bankAccountForm.labels.eftProviderWidnow':
    'Você será direcionado à plataforma de processamento do parceiro para concluir este pagamento. Quando terminar, será redirecionado novamente a esta página',
  'bankAccountForm.labels.termsFlywire':
    "Li, compreendi e concordo com os <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Termos de Uso</a> e a <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Política de Privacidade</a> da Flywire",
  'bankAccountForm.labels.termsDirectDebit':
    'Confirmo que sou o titular desta conta e o único signatário necessário para autorizar este débito direto',
  'bankAccountForm.labels.termsEft':
    "Li, compreendi e concordo com o <a class='fw-underline fw-text-primary-600' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Contrato de Débito Pré-Autorizado</a>",
  'bankAccountForm.labels.city': 'Cidade',
  'bankAccountForm.labels.country': 'País ou região',
  'bankAccountForm.labels.selectCountry': 'Selecione um país ou região',
  'bankAccountForm.title': 'Informações do titular da conta',
  'failure.tryAgain': 'Tentar novamente',
  'failure.title': 'Falha na transação',
  'failure.connectivity.message':
    'A operação falhou. Isso pode ser devido a problemas de conectividade.',
  'failure.message':
    'A transação falhou. Isso pode ser devido a problemas de conectividade. Tente novamente. Se o problema persistir, tente outra forma de pagamento ou entre em contato com seu banco',
  'sessionExpired.text': 'A sessão expirou',
  'LoadingError.title': 'Algo deu errado',
  'LoadingError.message': 'Ocorreu um erro ao carregar o formulário',
  'tokenizationForm.errors.noPaymentOptionsAvailable':
    'Não há opções de pagamento disponíveis para o país/região selecionado',
  'offerError.noOptions.card':
    'O tipo de cartão selecionado não é aceito. Use um tipo de cartão diferente.',
  'offerError.noOptions.bank':
    'A conta bancária selecionada não é aceita. Use uma conta bancária diferente.',
  'offerError.noOptions.other':
    'A forma de pagamento selecionada não é aceita. Use uma forma de pagamento diferente.',
  'bankAccountForm.labels.accountHolderType.personal': 'Conta pessoal',
  'bankAccountForm.labels.accountHolderType.business': 'Conta empresarial',
  'bankAccountForm.labels.name': 'Nome',
  'bankAccountForm.labels.businessName': 'Razão social',
  'bankAccountForm.labels.surname': 'Sobrenome',
  'bankAccountForm.labels.phone': 'Número de celular',
  'bankAccountForm.labels.email': 'E-mail',
  'bankAccountForm.labels.zip': 'CEP',
  'bankAccountForm.labels.accountAddress': 'Endereço',
  'bankAccountForm.labels.address': 'Endereço',
  'bankAccountForm.errors.dynamicFields': '{{field}} inválido',
  'bankAccountForm.labels.saveButton': 'Salvar',
  'bankAccountForm.labels.nextButton': 'Avançar',
  'bankAccountForm.labels.payButton': 'Pagar',
  'bankAccountForm.errors.cardNumber': 'Número de cartão inválido',
  'tokenizationForm.errors.cardNumber': 'Número de cartão inválido',
  'tokenizationForm.errors.cvv': 'Número CVV inválido',
  'bankAccountForm.errors.cvv': 'Número CVV inválido',
  'tokenizationForm.errors.unsupportedCardTypes': 'Somente {{acceptedCardsList}} são aceitos',
  'tokenizationForm.errors.unsupportedCardType': 'Somente {{acceptedCard}} é aceito',
  'tokenizationForm.errors.cardType.and': 'e',
  'tokenizationForm.errors.name': 'Nome inválido',
  'tokenizationForm.errors.email': 'E-mail inválido',
  'tokenizationForm.errors.country': 'País ou região inválido',
  'tokenizationForm.errors.state': 'Estado inválido',
  'tokenizationForm.errors.city': 'Cidade inválida',
  'tokenizationForm.errors.address': 'Endereço inválido',
  'tokenizationForm.errors.addressIsPoBox': 'Não aceitamos caixas postais no campo de endereço.',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'Os caracteres válidos são apenas A-Z e 0-9',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol':
    'Os caracteres válidos são apenas A-Z, 0-9 e "/, -"',
  'tokenizationForm.errors.zip': 'CEP inválido',
  'tokenizationForm.errors.expiryDate': 'Data de validade inválida',
  'bankAccountForm.errors.expiryDate': 'Data de validade inválida',
  'tokenizationForm.errors.surname': 'Sobrenome inválido',
  'tokenizationForm.errors.phone': 'Número de celular inválido',
  'tokenizationForm.errors.length': 'O campo é muito longo (máximo de 256 caracteres)',
  'tokenizationForm.errors.required.field': 'Campo obrigatório',
  'bankAccountForm.errors.name': 'Nome inválido',
  'bankAccountForm.errors.name.maxSizeExceeded': 'O nome é muito longo (máximo de 140 caracteres)',
  'form.errors.name.maxSizeExceeded': 'O nome é muito longo (máximo de {{limit}} caracteres)',
  'form.errors.surname.maxSizeExceeded':
    'O sobrenome é muito longo (máximo de {{limit}} caracteres)',
  'form.errors.business_name.maxSizeExceeded':
    'A razão social é muito longa (máximo de {{limit}} caracteres)',
  'form.errors.city.maxSizeExceeded': 'A cidade é muito longa (máximo de {{limit}} caracteres)',
  'form.errors.address.maxSizeExceeded':
    'O endereço é muito longo (máximo de {{limit}} caracteres)',
  'form.errors.date.wrongDate': 'Valor de data inválido',
  'bankAccountForm.errors.business_name': 'Razão social inválida',
  'bankAccountForm.errors.business_name.maxSizeExceeded':
    'A razão social é muito longa (máximo de 140 caracteres)',
  'bankAccountForm.errors.surname': 'Sobrenome inválido',
  'bankAccountForm.errors.surname.maxSizeExceeded':
    'O sobrenome é muito longo (máximo de 140 caracteres)',
  'bankAccountForm.errors.country': 'País ou região inválido',
  'bankAccountForm.errors.address': 'Endereço inválido',
  'bankAccountForm.errors.address.maxSizeExceeded':
    'O endereço é muito longo (máximo de 256 caracteres)',
  'bankAccountForm.errors.city': 'Cidade inválida',
  'bankAccountForm.errors.city.maxSizeExceeded':
    'A cidade é muito longa (máximo de 256 caracteres)',
  'bankAccountForm.errors.email': 'E-mail inválido',
  'bankAccountForm.errors.state': 'Estado inválido',
  'bankAccountForm.errors.iban': 'IBAN inválido',
  'bankAccountForm.errors.bic': 'Código BIC inválido',
  'bankAccountForm.errors.accountnumber': 'Número da conta inválido',
  'bankAccountForm.errors.sortcode': 'Sort code inválido',
  'bankAccountForm.errors.account_type': 'Tipo de conta inválido',
  'bankAccountForm.errors.addressIsPoBox': 'Não aceitamos caixas postais no campo de endereço.',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'Os caracteres válidos são apenas A-Z e 0-9',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'Os caracteres válidos são: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'CEP inválido',
  'bankAccountForm.errors.phone': 'Número de celular inválido',
  'bankAccountForm.errors.ach_account_number': 'Número da conta inválido',
  'bankAccountForm.errors.routing_number': 'Número de roteamento inválido',
  'bankAccountForm.errors.offer':
    'Não há opções de pagamento disponíveis. Se você tem uma conta bancária em outro país/região, selecione esse país/região ou escolha outro cartão e tente novamente. Se isso não resolver o problema, entre em contato com {{recipientName}}',
  'binLookUp.unableToFindCard.message':
    'Erro no cartão. Revise os dados informados ou tente outro cartão.',
  'binLookUp.warning.message': 'Não foi possível verificar seu cartão',
  'confirmationPage.labels.edit': 'Editar',
  'confirmationPage.labels.confirm': 'Confirmar',
  'confirmationPage.labels.title': 'Revise as informações do mandato',
  'confirmationPage.labels.typeOfPayment': 'Tipo de pagamento',
  'confirmationPage.labels.paymentRecipient': 'Destinatário do pagamento',
  'confirmationPage.labels.typeOfPayment.oneOff': 'Pagamento único',
  'confirmationPage.labels.typeOfPayment.recurring': 'Recorrente',
  'confirmationPage.labels.directDebitInformation': 'Informações do débito direto',
  'confirmationPage.labels.directDebitInformation.title': 'Instruções ao seu banco',
  'confirmationPage.labels.directDebitInformation.creditor': 'Credor',
  'confirmationPage.labels.directDebitInformation.creditorId': 'ID do credor',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': 'Nome no seu extrato',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'ID do usuário do serviço',
  'confirmationPage.labels.directDebitInformation.address': 'Endereço da Flywire',
  'confirmationPage.labels.directDebitInformation.originator': 'Originador',
  'confirmationPage.labels.directDebitInformation.originatorId': 'ID do originador',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Endereço do originador',
  'confirmationPage.labels.bankAccountInformation': 'Informações da conta bancária',
  'confirmationPage.labels.bankAccountInformation.name': 'Nome',
  'confirmationPage.labels.bankAccountInformation.iban': 'Número IBAN',
  'confirmationPage.labels.bankAccountInformation.email': 'E-mail',
  'confirmationPage.labels.bankAccountInformation.country': 'País ou região',
  'confirmationPage.labels.bankAccountInformation.state': 'Estado',
  'confirmationPage.labels.bankAccountInformation.city': 'Cidade',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'Código BIC',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'Número da conta',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'Sort code',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'Número da conta',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'Número de roteamento',
  'confirmationPage.labels.bankAccountInformation.accountType': 'Tipo de conta',
  'confirmationPage.labels.paymentInformation': 'Informações do pagamento',
  'confirmationPage.labels.paymentInformation.amount': 'Valor',
  'confirmationPage.labels.changeAccountEft': 'Alterar dados da conta bancária',
  'confirmationPage.labels.editPayerEft': 'Editar dados do pagador',
  'confirmationPage.labels.useAccountEft': 'Usar a conta com final **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'Conta bancária vinculada com sucesso',
  'confirmationPage.labels.termsSepa':
    'Ao assinar este formulário de mandato, você autoriza (A) a FLYWIRE EUROPE UAB a enviar instruções ao seu banco para debitar sua conta e (B) o seu banco a debitar sua conta de acordo com as instruções da FLYWIRE EUROPE UAB. Você será notificado com pelo menos 3 dias de antecedência antes da cobrança.',
  'confirmationPage.labels.termsBacs':
    'Instrua seu banco a pagar os débitos diretos da Flywire Payments Limited a partir da conta indicada nesta instrução, sujeito às salvaguardas asseguradas pela Garantia de Débito Direto. Entendo que esta instrução pode permanecer com a Flywire Payments Limited e, nesse caso, os dados serão repassados eletronicamente ao meu banco/sociedade de crédito imobiliário.',
  'confirmationPage.labels.termsAch': `
     Ao clicar em "Confirmar", você declara ter a devida autoridade para autorizar, e autoriza a Flywire, em nome do destinatário indicado
     ("Beneficiário"), a debitar a conta bancária informada por você por qualquer valor devido referente a cobranças decorrentes do uso dos
     serviços e/ou da compra de produtos do Beneficiário e, se necessário, a corrigir débitos indevidos, nos termos do Beneficiário, até que esta
     autorização seja revogada. Caso uma transação ACH seja rejeitada por saldo insuficiente, entendo que será cobrada uma taxa
     NSF e que a Flywire poderá, a seu critério, tentar processar a cobrança novamente.
     `,
  'confirmationPage.labels.termsAch2': `
     Se você utilizar ou adquirir periodicamente produtos e/ou serviços adicionais do Beneficiário, nos termos do Beneficiário, você autoriza a
     Flywire, em nome do Beneficiário, a debitar periodicamente a conta bancária informada por você. Pagamentos que não estejam abrangidos pelo débito
     autorizado acima só serão debitados após a obtenção de sua autorização por meio da sua conta ou, alternativamente, de uma senha, código ou outro
     equivalente de assinatura.
     `,
  'confirmationPage.labels.termsAch3': `
     Você pode revogar esta autorização a qualquer momento entrando em contato com o Beneficiário. A revogação deve ser recebida com pelo menos [10 dias úteis]
     de antecedência em relação ao próximo pagamento programado.
    `,
  'confirmationPage.labels.print': 'Imprimir contrato',
  'amountPanel.labels.amountFromLabel': 'Você pagará',
  'amountPanel.labels.surchargeFeeInfo': 'taxa do cartão incluída',
  'amountPanel.labels.serviceFeeInfo': 'taxa de serviço incluída',
  'amountPanel.labels.serviceFeePercentageInfo':
    '{{percentage}} de taxa de serviço (mín. {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': '{{percentage}} de taxa de serviço',
  'amountPanel.labels.whyThisFee': 'Por que esta taxa?',
  'amountPanel.labels.currencyChangeWarning':
    'A moeda foi alterada para corresponder à moeda do seu cartão',
  'amountPanel.labels.amountToLabel': '{{recipientName}} receberá',
  'amountPanel.labels.editCurrencySelection': 'Editar seleção de moeda',
  'amountPanel.labels.discountApplied': 'Desconto de {{amount}} aplicado',
  'currencyInfoBanner.labels.currencyInfo':
    'Seus próximos pagamentos serão cobrados em <b>{{code}} ({{symbol}})</b>.',
  'currencyInfoBanner.error.offerNotFound': 'Nenhuma opção de pagamento disponível.',
  AX: 'Ilhas Aland',
  AD: 'Andorra',
  BG: 'Bulgária',
  AT: 'Áustria',
  BE: 'Bélgica',
  HR: 'Croácia',
  CY: 'Chipre',
  CZ: 'Tchéquia',
  DK: 'Dinamarca',
  EE: 'Estônia',
  FI: 'Finlândia',
  FR: 'França',
  GP: 'Guadalupe',
  DE: 'Alemanha',
  GR: 'Grécia',
  HU: 'Hungria',
  IS: 'Islândia',
  IE: 'Irlanda',
  VA: 'Cidade do Vaticano',
  IT: 'Itália',
  LI: 'Liechtenstein',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  YT: 'Mayotte',
  MT: 'Malta',
  MQ: 'Martinica',
  ES: 'Espanha',
  NO: 'Noruega',
  NL: 'Países Baixos',
  PL: 'Polônia',
  PT: 'Portugal',
  SE: 'Suécia',
  RE: 'Reunião',
  RO: 'Romênia',
  CH: 'Suíça',
  BL: 'São Bartolomeu',
  GB: 'Reino Unido',
  MC: 'Mônaco',
  MF: 'São Martinho',
  PM: 'São Pedro e Miquelão',
  SM: 'San Marino',
  SK: 'Eslováquia',
  SI: 'Eslovênia',
  GF: 'Guiana Francesa',
  LV: 'Letônia',
  CA: 'Canadá',
  US: 'Estados Unidos',
  'inlineDialogConfirmation.labels.title': 'Confirmação necessária: cancelar processo',
  'inlineDialogConfirmation.labels.body': 'Tem certeza de que deseja cancelar este processo?',
  'inlineDialogConfirmation.labels.closeButton': 'Não',
  'inlineDialogConfirmation.labels.confirmButton': 'Sim',
  'priceBreakDown.price.toggle.button': 'Detalhamento do preço',
  'priceBreakDown.fx.toggle.button': 'Detalhamento do câmbio',
  'priceBreakDown.fees': 'Taxas',
  'priceBreakDown.service_fees': 'Taxa de serviço',
  'priceBreakDown.card_fees': 'Taxa do cartão',
  'priceBreakDown.exchange.rate': 'Taxa de câmbio',
  'priceBreakDown.markup.rate': 'Margem sobre a taxa do BCE',
  'priceBreakDown.discount': 'Desconto',
  'priceBreakDown.discount.coupon': 'Desconto ({{code}})',
  'priceBreakDown.original_amount': 'Valor original',
  'priceBreakDown.total': 'Total',
  'acceptProposedOfferBanner.textInfo':
    "Este cartão não é elegível. Toque em 'Aceitar' para seguir para as formas de pagamento aceitas ou ",
  'acceptProposedOfferBanner.textInfoWithoutChangeCard':
    "Este cartão não é elegível. Toque em 'Aceitar' para seguir para as formas de pagamento aceitas.",
  'acceptProposedOfferBanner.link.option': 'altere o cartão',
  'acceptProposedOfferBanner.labels.accept': 'Aceitar',
  'chooseCurrencyBanner.title': 'Escolha a moeda',
  'chooseCurrencyBanner.message':
    'A moeda do seu cartão é diferente da moeda do país de cobrança. Selecione a moeda que deseja usar nesta transação:',
  'banner.offer.validation.message': 'Escolha uma ação para continuar.',
  'instructions.offline.amount.label': 'Valor a pagar',
  'instructions.offline.reference.label': 'Referência / ID do pagamento',
  'instructions.offline.paymentId.label': 'ID do pagamento',
  'instructions.offline.paymentReferenceMissing': 'A referência do pagamento não está presente',
  'instructions.offline.missing.title': 'Não foi possível gerar as instruções de pagamento',
  'instructions.offline.missing.message':
    'Tente novamente. Se o problema persistir, tente outra forma de pagamento ou entre em contato com seu banco.',
  'instructions.offline.title': 'Instruções de pagamento',
  'instructions.offline.understand':
    'Entendo que preciso iniciar uma transferência pelo meu banco.<br />Clique aqui para fechar.',
  'instructions.offline.download.button': 'Baixe as instruções da transferência bancária',
  'instructions.offline.howToBankTransfer': 'Como fazer uma transferência bancária?',
  'instructions.offline.howToBankTransfer.modal.title': 'Como concluir sua transferência bancária',
  'instructions.offline.howToBankTransfer.modal.intro':
    'Veja abaixo as diferentes opções para concluir sua transferência bancária:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle':
    'Internet banking / aplicativo do banco',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription':
    'Se você tem internet banking ou o aplicativo do seu banco, basta acessar sua conta e fazer a transferência por conta própria.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': 'Visita presencial a uma agência',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription':
    'Ao visitar uma agência do seu banco, você pode informar os dados da conta necessários, que constam nas suas instruções de pagamento, para fazer a transferência.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'Transferência por telefone',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription':
    'Você também pode ligar para o seu banco e autorizá-lo a iniciar a transação em seu nome.',
  'instructions.offline.referenceWarning':
    'Inclua esta referência para que possamos identificar seu pagamento',
  'instructions.offline.dueDateLabel': 'Transfira os fundos até:',
  'instructions.offline.processingTime':
    'A Flywire receberá os fundos <strong>2 a 3 dias úteis</strong> após você iniciar a transferência',
  'elementsInstructions.qr.description': 'Leia o QR code para concluir o pagamento',
  'elementsInstructions.qr.payid.description':
    'Abra o aplicativo do seu banco e envie para o PayID abaixo. Este endereço é exclusivo da sua conta — os pagamentos são identificados automaticamente.',
  'elementsInstructions.qr.scan': 'Ou leia com a câmera do celular',
  'elementsInstructions.qr.waitingForPayment': 'Aguardando a conclusão do pagamento',
  'elementsInstructions.externalAction.generic': 'Conclua o pagamento para continuar.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone':
    'Uma solicitação de pagamento M-Pesa foi enviada para o seu celular.\nConclua o pagamento para continuar.',
  'elementsInstructions.redirect.title': 'Conclua seu pagamento',
  'elementsInstructions.redirect.description':
    'Você será direcionado à plataforma de processamento do parceiro para concluir este pagamento. Quando terminar, será redirecionado novamente a esta página.',
  'elementsInstructions.redirect.button': 'Fazer o pagamento',
  'documentCollector.collapsibleTitle': 'Enviar documentação',
  'documentCollector.uploadingDocument': 'Enviando documento',
  'documentCollector.deleteFile': 'Excluir {{fileName}}',
  'documentCollector.deletingFile': 'Excluindo {{fileName}}',
  'documentCollector.moreInfoModal': 'Mais informações',
  'documentCollector.errorsModal': 'Avisos do documento',
  'documentCollector.documentList': 'Lista de documentos',
  'documentCollector.upload': 'Enviar',
  'documentCollector.errorBlockLabel': 'Avisos do documento',
  'documentCollector.reUpload': 'Enviar novamente',
  'documentCollector.errorsFoundOne': '{{count}} aviso encontrado',
  'documentCollector.errorsFoundOther': '{{count}} avisos encontrados',
  'documentCollector.validationNote':
    '<b>Envio do arquivo concluído!</b> Nossa verificação automática identificou possíveis problemas. Se o seu documento contém todas as informações necessárias, ignore este aviso.',
  'documentCollector.antivirus': 'Verificação antivírus do arquivo',
  'documentCollector.antivirusStep': 'Verificação antivírus do arquivo 1/2',
  'documentCollector.verifyingStep': 'Verificação dos documentos 2/2',
  'documentCollector.invalidFile':
    'Arquivo inválido detectado. O arquivo pode estar protegido por senha ou criptografado. Verifique e tente novamente.',
  'documentCollector.moreInfo': 'Mais informações',
  'documentCollector.required': 'Obrigatório',
  'documentCollector.review': 'Revisar',
  'documentCollector.acceptedFileTypes':
    'Tipos de arquivo aceitos: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': 'Tamanho máximo do arquivo: <b>{{maxFileSize}} MB.</b>',
  'documentCollector.acceptedFileAndFileSize':
    'Tipos de arquivo aceitos: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>. Tamanho máximo do arquivo: <b>{{maxFileSize}} MB.</b>',
  'documentCollector.docVerifyError.missingInfo':
    'Verifique se o documento contém todas as informações solicitadas.',
  'documentCollector.docVerifyError.documentTypeError':
    'Este arquivo não parece ser um(a) {{documentType}}. Verifique os requisitos e envie um novo arquivo, se necessário.',
  'documentCollector.docVerifyError.documentIdentificationTypeError':
    'O documento enviado não parece ser um(a) {{documentType}}, que é o tipo de identificação selecionado para este pagamento. Verifique e envie novamente, se necessário.',
  'documentCollector.docVerifyError.documentType.errorNote':
    '<b>Observação</b>: o envio de documentos incorretos pode causar atrasos no processamento do pagamento. Se os seus documentos forem válidos, desconsidere este aviso.',
  'documentCollector.duplicateFile':
    'Documento duplicado detectado. Envie um arquivo diferente para cada item.',
  'oneOff.savePaymentMethod.label': 'Salvar esta forma de pagamento para pagamentos futuros',
  'lrs.transaction.title': 'Transação',
  'lrs.transaction.date': 'Data',
  'lrs.transaction.amount': 'Valor',
  'lrs.transaction.amountHint': 'Valor em moeda estrangeira',
  'lrs.transaction.adBranch': 'Nome e endereço da agência AD',
  'lrs.transaction.add': 'Adicionar mais transações',
  'lrs.signatureModal.title': 'Assinar o documento',
  'lrs.signatureModal.tab.draw': 'Desenhar assinatura',
  'lrs.signatureModal.tab.upload': 'Enviar assinatura',
  'lrs.signatureModal.draw.text':
    'Assine no espaço abaixo usando o mouse ou o dedo para aceitar o documento.',
  'lrs.signatureModal.legalAlert':
    'Assinaturas inválidas invalidarão todo o processo LRS. Certifique-se de assinar com a <b>assinatura do titular do PAN</b>. Uma cópia do documento será enviada ao e-mail do pagador informado para o seu registro. Tipos de arquivo aceitos: <b>PNG</b>, <b>JPG</b>.',
  'lrs.signatureModal.draw.clear': 'Limpar',
  'lrs.signatureModal.upload.label': 'Envie uma imagem da sua assinatura',
  'lrs.signatureModal.upload.input': 'Enviar assinatura',
  'lrs.signatureModal.upload.remove': 'Remover',
  'lrs.signatureModal.upload.hint':
    'Tipos de arquivo aceitos: <b>PNG</b>, <b>JPG</b>. Tamanho máximo do arquivo: <b>8 MB</b>',
  'lrs.signatureModal.upload.typeError': 'Tipo de arquivo não aceito. Envie um arquivo PNG ou JPG.',
  'lrs.signatureModal.upload.sizeError': 'O arquivo deve ter menos de 8 MB',
  'lrs.signatureModal.upload.readError': 'Não foi possível ler o arquivo. Tente novamente.',
  'lrs.signatureModal.confirm': 'Aceitar e enviar',
  'lrs.signatureModal.previewError':
    'Algo deu errado ao gerar a pré-visualização. Tente novamente.',
  'lrs.signatureModal.uploadError': 'Algo deu errado ao enviar. Tente novamente.',
  'lrs.previewLink.label': 'Pré-visualizar documento',
  'lrs.documents.continueButton': 'Continuar para enviar o formulário LRS',
  'lrs.form.declaration':
    "Conforme o Liberalised Remittance Scheme (LRS), o governo da Índia e o Reserve Bank of India (RBI) agora exigem um formulário de Declaração LRS (denominado \"A2 cum LRS Declaration\") para transferir fundos ao exterior. É OBRIGATÓRIO enviar sua Declaração LRS antes de iniciar a transferência bancária; caso contrário, o processamento do seu pagamento poderá sofrer atrasos. Para mais detalhes sobre como concluir esta etapa, clique <a href='https://help.flywire.com/hc/en-us/articles/360012963774' target='_blank'>aqui</a> para saber mais.",
  'lrs.form.bankAccountAndStudentInfo.title': 'Conta bancária e informações do aluno',
  'lrs.form.bankAccountAndStudentInfo.text':
    'Informe a conta bancária da qual os fundos serão transferidos. Se você contratou um empréstimo estudantil e os fundos serão liberados a partir da conta do empréstimo, informe o número da conta do empréstimo. Transferências de contas NRO/NRE não são aceitas. Como ID do aluno, você pode usar o ID do aluno, o ID da inscrição ou o número de referência.',
  'lrs.form.details.title': 'Detalhes das transações internacionais realizadas no ano fiscal atual',
  'lrs.form.details.text':
    'Informe os detalhes de quaisquer transações em moeda estrangeira realizadas durante o ano fiscal atual (<b>abril de {{startYear}} a março de {{endYear}}</b>). Deixe em branco se você não realizou nenhuma.',
  'lrs.form.bankAccountNumber': 'Número da conta bancária',
  'lrs.form.studentFullName': 'Nome completo do aluno',
  'lrs.form.studentId': 'ID do aluno',
  'lrs.form.required': 'Obrigatório',
  'lrs.form.signAndSubmit': 'Assinar e enviar o formulário LRS',
  'lrs.title': 'Enviar documentação e o formulário LRS',
  'lrs.description':
    'As instruções de pagamento por transferência bancária serão exibidas após a conclusão desta etapa.',
  'lrs.tabs.documents': '1. Enviar documentos',
  'lrs.tabs.form': '2. Enviar formulário LRS',
  'recipientFields.requiredField': '(*) campo obrigatório',
  'paymentMethodSelector.loading': 'Carregando formas de pagamento...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'Aceita cartões de débito e crédito',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'Aceita cartões de débito',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'Aceita cartões de crédito',
  'paymentMethodSelector.cards.surchargeWarning':
    'Podem ser aplicadas taxas adicionais, dependendo do tipo de cartão e do país emissor.',
  'paymentMethodSelector.subtitle.default': 'Pagar com {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay': 'Pagar com sua carteira Google Pay salva',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID ou Face ID — somente no Safari',
  'paymentMethodSelector.subtitle.paypal': 'Pagar com sua conta PayPal',
  'paymentMethodSelector.subtitle.wechat': 'Pagar com WeChat — disponível na China continental',
  'paymentMethodSelector.subtitle.alipay': 'Pagar com Alipay',
  'paymentMethodSelector.subtitle.trustly': 'Pagamento via open banking'
} as const;

export { ptBR };
